<script setup lang="ts">
import { ComponentSize } from '#ds-config/constants'

import type { RIconProps } from './RIcon.types.ts'

defineProps<RIconProps>()

const sizeToTypographyClass = {
  '2xl': 'h5-regular',
  large: 'body-1-regular',
  medium: 'body-2-regular',
  small: 'body-3-regular',
  xl: 'h6-regular',
}
</script>

<template>
  <i
    :style="{
      ...(typeof size === 'number' ? { fontSize: `${size}px` } : {}),
    }"
    :class="{
      ...(size && Object.values(ComponentSize).includes(size as ComponentSize)
        ? { [sizeToTypographyClass[size as ComponentSize]]: true }
        : {}),
      [icon]: true,
      iconify: true,
      [`text-${color}`]: true,
      [`${iconClass}`]: !!iconClass,
    }"
  ></i>
</template>
